export const QueryKeys = {
  getAuthUser: "getAuthUser",
  getGenreList: "getGenreList",
  getAreaList: "getAreaList",
  getAdminMemberList: "getAdminMemberList",
  getAdminMemberById: "getAdminMemberById",
  getOrganizationList: "getOrganizationList",
  getBrandList: "getBrandList",
  getBrandById: "getBrandById",
  getStoreList: "getStoreList",
  getStoreById: "getStoreById",
  getStaffList: "getStaffList",
  getStaffProfile: "getStaffProfile",
  getInfluencerList: "getInfluencerList",
  getInfluencerById: "getInfluencerById",
  getInfluencerTrackRecord: "getInfluencerTrackRecord",
  /** IF 詳細のダッシュボード（[getInfluencerDashboard, IF, 店舗, months]） */
  getInfluencerDashboard: "getInfluencerDashboard",
  /** 基本情報タブの住所の表示条件（自店舗との通販のやりとりの件数）。一覧（getInfluencerTicketList）とキャッシュを分ける */
  getInfluencerOrderTicketTotal: "getInfluencerOrderTicketTotal",
  getFavoriteInfluencerList: "getFavoriteInfluencerList",
  getPrTicketList: "getPrTicketList",
  getTicketList: "getTicketList",
  getStoreTicketList: "getStoreTicketList",
  getTicketById: "getTicketById",
  getInfluencerTicketList: "getInfluencerTicketList",
  getInfluencerTicketListMinimal: "getInfluencerTicketListMinimal",
  getInfluencerTicketById: "getInfluencerTicketById",
  getInfluencerStatusLogList: "getInfluencerStatusLogList",
  getInfluencerTicketPostList: "getInfluencerTicketPostList",
  getStoreInfluencerTicketStatuses: "getStoreInfluencerTicketStatuses",

  fecthRoomMessage: "fecthRoomMessage",
  fecthAllRoom: "fecthAllRoom",
  fetchRoomById: "fetchRoomById",
  fetchRoomByTicketId: "fetchRoomByTicketId",
  /** IF 詳細のやりとり一覧タブの未読（表示中のページの行の room。旧テーブルの fetchRoomByTicketId とは別のキー） */
  getInfluencerInteractionRooms: "getInfluencerInteractionRooms",
  /** IF 詳細の評価タブ（#1674）。店舗→IF 評価の集計・一覧（一覧のキーには店舗・並び・件数を入れる） */
  getInfluencerRatingSummary: "getInfluencerRatingSummary",
  getInfluencerRatingList: "getInfluencerRatingList",

  getStoreClicks: "getStoreClicks",
  getStoreTicketActions: "getStoreTicketActions",
  getStoreFavorites: "getStoreFavorites",
  getStoreRatings: "getStoreRatings",
  getStoreInfluencerTicketsSummary: "getStoreInfluencerTicketsSummary",
  getStorePostsSummary: "getStorePostsSummary",
  getInsightsByStoreId: "getInsightsByStoreId",
  getInfluencerTicketPostsCount: "getInfluencerTicketPostsCount",
  getInfluencerTicketsCount: "getInfluencerTicketsCount",
  getInsightsByTicketIds: "getInsightsByTicketIds",

  /* ------------------------------------------------------------------ */
  /* dashboard top（HOME・実装設計書 §5.7）                              */
  /*                                                                    */
  /* P2-2 (#1541)〜P2-7 (#1546) が同じファイルに追記するとコンフリクトする */
  /* ため、P2-1 (#1540) で11個まとめて追加してある。担当issueは            */
  /* **このキーを使うだけ**でよく、本ファイルを編集する必要はない。         */
  /*                                                                    */
  /* ⚠ お知らせ2種は例外: staff id + notice session。storeId/invalidateは不要。 */
  /* その他のQueryKey には必ず `storeId` を含める。                            */
  /*   例: `[QueryKeys.getHomeVisitInfluencers, storeId, jstDate]`       */
  /*   含めないとストア切替後に前ストアのデータが残る。                     */
  /*   日付・期間・ステータス種別など、レスポンスが変わる引数もキーに含める。 */
  /*                                                                    */
  /* ストア切替時は StoreSelectorMenu の一覧で全 store-scoped key を破棄する。 */
  /* ------------------------------------------------------------------ */
  getHomeNotices: "getHomeNotices",
  getHomeUnconfirmedNotices: "getHomeUnconfirmedNotices",
  getHomeBanners: "getHomeBanners",
  getHomeVisitInfluencers: "getHomeVisitInfluencers",
  getHomeVisitCounts: "getHomeVisitCounts",
  getHomeUnreadMessageCounts: "getHomeUnreadMessageCounts",
  getHomeAnalyticsSummary: "getHomeAnalyticsSummary",
  getHomeAnalyticsTrends: "getHomeAnalyticsTrends",
  getHomeLatestPosts: "getHomeLatestPosts",
  getHomeStoreRatings: "getHomeStoreRatings",
  getHomeArticles: "getHomeArticles",
} as const;
